export default __webpack_public_path__ + "static/media/SF-Pro-Italic.77c1fd9b.ttf";